import { IBillingBlocker } from './types';

const asText = (value: unknown): string | null => {
  if (typeof value === 'number' && Number.isFinite(value)) return String(value);
  return typeof value === 'string' && value.trim() ? value.trim() : null;
};

const toBlocker = (entry: any): IBillingBlocker => ({
  //  Not sent yet; read when present (BOPS-440).
  patientId: asText(entry.patient_id),
  patientName: asText(entry.patient),
  mrn: asText(entry.mrn),
  episodeOfCareId: asText(entry.episode_of_care_id),
  episodeTitle: asText(entry.eoc_title),
  payerPlan: asText(entry.payer_plan),
  discipline: asText(entry.discipline),
  dateOfService: asText(entry.date_of_service),
  type: asText(entry.blocker_type),
  reason: asText(entry.reason),
  customerFixable: entry.customer_fixable === true,
});

/**
 * BOPS-440 — the entries of a `POST /billing/blockers` answer (RA-2285, report-automation): a
 * top-level JSON array, one entry per blocker per charge, already scoped to the requested
 * facility. Returns `null` when the body is not an array, so a malformed answer reads as "could
 * not check" rather than as "nothing blocking".
 */
export const readBillingBlockers = (body: unknown): IBillingBlocker[] | null => {
  if (!Array.isArray(body)) return null;
  return body.filter((entry) => entry && typeof entry === 'object').map(toBlocker);
};

export default readBillingBlockers;
